import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana88Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1461_4984)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M575.972 643.73L552.455 559.459L481.902 579.057L552.455 657.448C571.269 668.423 575.972 652.875 575.972 643.73Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M430.946 537.901L481.901 579.056L552.453 559.458L538.735 508.504L430.946 537.901Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M383.912 498.707L430.946 537.902L474.065 526.144L456.427 461.471C436.045 469.31 402.204 473.883 387.831 475.189C376.856 481.461 380.645 493.481 383.912 498.707Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M503.464 443.831C495.624 448.535 468.841 457.55 456.429 461.469L474.067 526.143L538.74 508.505C533.514 489.56 522.67 450.886 521.102 447.751C519.142 443.831 513.263 437.952 503.464 443.831Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1461_4984" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1461_4984" transform="matrix(0.00268817 0 0 0.0035638 -6.98221 -2.87458)"/>
    </pattern>
    <image id="image0_1461_4984" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};